module.exports = __webpack_public_path__ + "media/images/landing/home/happy-de790a65b97acd9dbb8e9a035bafaf77.png";